namespace Solovis.UI {

     /*
     * VerticalOrderedListBuilder provides an easy way to build a list editor with a custom editor.
     * 
     * options:
     *  values: array of initial values
     *  itemTypeLabel: (optional) label for the item type, so we can say "Add Item" instead of just "Add".
     *  showEditLinks: (bool, default: false) show edit links that will call "showEditor" on value returned from editorCreator.
     *  maxItems: the maximum number of items the list will contain.
     * 
     *  editorCreator: function (editorDiv, initialValue) that is supposed to create the editor inside
     *    of the editorDiv using the initial value. It should return an object that has a getValue() method
     *    and optionally has a destroy() method.
     * 
     *  newValueGenerator: (optional) function () that should return a blank value to use for new row.
     */
    export interface VerticalOrderedListBuilderOptions extends Solovis.UI.BaseControlOptions {
        values: any[];
        itemTypeLabel?: string;
        maxItems?: number;
        editorCreator: any;
        newValueGenerator?: any; 
        showEditLinks?: any;  
        showAddButton?: boolean;    

        itemAddedOrRemoved?: () => any;
    }

    export class VerticalOrderedListBuilder extends Solovis.UI.BaseControl {

        public _initialValues;
        public _itemTypeLabel;
        public _maxItems;
        public _editorCreator;
        public _newValueGenerator;
        public _showEditLinks;
        public _showAddButton;

        public _listDiv: JQuery;
        public _addNewValueButton: JQuery;


        constructor(options: VerticalOrderedListBuilderOptions) {
            super(options);

            var self = this;

            this._initialValues = options.values ? options.values : null;

            this._itemTypeLabel = options.itemTypeLabel ? options.itemTypeLabel : null;

            this._maxItems = options.maxItems ? options.maxItems : null;

            this._editorCreator = options.editorCreator ? options.editorCreator : null;
            this._newValueGenerator = options.newValueGenerator ? options.newValueGenerator : null;

            this._showEditLinks = options.showEditLinks ? true : false;
            this._showAddButton = Solovis.isNotNull(options.showAddButton) ? options.showAddButton : true;
        }


        public doInit() {
        }

        public doRender() {
            var self = this;

            this._listDiv = $("<div>").addClass("vertical-ordered-list-builder-list").appendTo(this.container);

            if (this._initialValues && this._initialValues.length > 0) {
                // Add existing values if we have loaded existing values.
                $(this._initialValues).each(function (i, initialValue) {
                    self._addNewValueRow(initialValue);
                });
            }

            // Show link for adding new value.
            if (this._showAddButton) {
                var addNewValueRow = $("<div>").appendTo(this.container);

                var addText = "Add";
                if (this._itemTypeLabel) {
                    addText += " " + this._itemTypeLabel;
                }

                this._addNewValueButton = $("<button>").text(addText).appendTo(addNewValueRow)
                    .click(function () {
                        var newValue = null;
                        if (self._newValueGenerator) {
                            newValue = self._newValueGenerator();
                        }
                        self._addNewValueRow(newValue);
                    });

                this._updateAddNewValueButtonVisibility();
            }
        }

        public _addNewValueRow(initialValue) {
            var self = this;

            var valueDiv = $("<div>").addClass("solovis-vol-item").addClass("clear-fix").appendTo(this._listDiv);            

            var valueDivElement: any = valueDiv.get(0);

            // Add controls for removing value and moving up and down.
            var rowControlDiv = $("<div>").css("float", "left").appendTo(valueDiv)
                .css("vertical-align", "top")
                .css("padding-right", "10px");

            var removeLink = $("<a>")
                .html('<span class="fa fa-remove"></span>')
                .attr("title", "Remove")
                .css("display", "inline-block")
                .css("padding-right", "5px")
                .appendTo(rowControlDiv)
                .click(function () {
                    self._removeValueRow(valueDivElement);
                });

            var upLink = $("<a>")
                .html('<span class="fa fa-arrow-up"></span>')
                .attr("title", "Move Up")
                .css("display", "inline-block")
                .appendTo(rowControlDiv)
                .click(function () {
                    self._moveValueRowUp(valueDivElement);
                });

            var downLink = $("<a>")
                .html('<span class="fa fa-arrow-down"></span>')
                .attr("title", "Move Down")
                .css("margin-left", "5px")       
                .css("display", "inline-block")
                .appendTo(rowControlDiv)
                .click(function () {
                    self._moveValueRowDown(valueDivElement);
                });

            if (this._showEditLinks) {
                var editLink = $("<a>")
                    .html('<span class="fa fa-pencil"></span>')
                    .attr("title", "Edit")
                    .css("margin-left", "5px")                    
                    .css("vertical-align", "top")
                    .css("display", "inline-block")
                    .appendTo(rowControlDiv)
                    .click(function () {
                        self._showEditor(valueDivElement);
                    });
            }

            var editorDiv = $("<div>").css("margin-left", "65px").appendTo(valueDiv);

            var editorInfo = this._editorCreator(editorDiv, initialValue);

            valueDivElement.__editorInfo = editorInfo;
            valueDivElement.__editorDiv = editorDiv;

            valueDivElement.__upLink = upLink;
            valueDivElement.__downLink = downLink;

            this._updateUpDownArrowVisibility();

            this._updateAddNewValueButtonVisibility();
        }

        public _removeValueRow(valueDivElement) {
            $(valueDivElement).remove();

            this._updateUpDownArrowVisibility();

            this._updateAddNewValueButtonVisibility();

            this.notifyItemAddedOrRemoved();
        }

        public getItemCount() {
            return this._listDiv.children("div").length;
        }

        public _moveValueRowUp(valueDivElement) {
            var index = $(valueDivElement).index();
            if (index > 0) {
                var prevItem = $(valueDivElement).prev();
                $(valueDivElement).insertBefore(prevItem);
            }

            this._updateUpDownArrowVisibility();
        }

        public _moveValueRowDown(valueDivElement) {
            var index = $(valueDivElement).index();
            var totalCount = this._listDiv.children("div").length;
            if (index < totalCount) {
                var nextItem = $(valueDivElement).next();
                if (nextItem) {
                    $(valueDivElement).insertAfter(nextItem);
                }
            }

            this._updateUpDownArrowVisibility();
        }

        public _updateUpDownArrowVisibility() {
            if (this._listDiv) {
                var childDivs = this._listDiv.children("div");
                var childDivsLength = childDivs.length;
                childDivs.each(function (i, valueDivElement: any) {
                    if (i == 0) {
                        valueDivElement.__upLink.css("visibility", "hidden");
                    }
                    else {
                        valueDivElement.__upLink.css("visibility", "visible");
                    }

                    if (i == (childDivsLength - 1)) {
                        valueDivElement.__downLink.css("visibility", "hidden");
                    }
                    else {
                        valueDivElement.__downLink.css("visibility", "visible");
                    }
                });
            }
        }

        public _updateAddNewValueButtonVisibility() {            
            if (Solovis.isNotNull(this._maxItems) && this.getItemCount() >= this._maxItems) {
                if (this._addNewValueButton) {
                    this._addNewValueButton.hide();
                }
            }
            else if (this._addNewValueButton) {
                this._addNewValueButton.show();
            }
        }

        public _showEditor(valueDivElement) {
            var editorInfo = valueDivElement.__editorInfo;
            if (editorInfo.showEditor) {
                editorInfo.showEditor();
            }
        }

        public getValues() {
            if (this._listDiv) {
                var values = [];

                this._listDiv.children("div").each(function (i, valueDivElement: any) {
                    var editorInfo = valueDivElement.__editorInfo;

                    var value = editorInfo.getValue();

                    if (value !== null) {
                        values.push(value);
                    }
                });

                return values.length > 0 ? values : null;
            }
            else {
                return this._initialValues;
            }
        }

        /**
         * Returns the editorInfo object (as returned by editorCreator) for each currently
         * live row, in order. Rows removed via the remove link are never included, since this
         * reads directly off the current DOM children rather than a separately tracked list.
         */
        public getEditors() {
            if (!this._listDiv) {
                return [];
            }

            var editors = [];

            this._listDiv.children("div").each(function (i, valueDivElement: any) {
                editors.push(valueDivElement.__editorInfo);
            });

            return editors;
        }

        public addValue(value) {
            this._internalAddValue(value);
        }

        private _internalAddValue(value, suppressEvent?: boolean) {
            this._addNewValueRow(value);
            if (!suppressEvent) {
                this.notifyItemAddedOrRemoved();
            }
        }

        /**
         * Remove all items.
         */
        public clear() {
            this._listDiv.children().remove();
            this.notifyItemAddedOrRemoved();
        }

        public setValues(itemList) {
            let self = this;

            this._listDiv.children().remove();

            if (!_.isEmpty(itemList)) {
                $(itemList).each(function (i, item) {
                    self._internalAddValue(item, true);
                });
            }

            this.notifyItemAddedOrRemoved();
        }

        public doDestroy() {
            if (this._listDiv) {
                this._listDiv.children("div").each(function (i, valueDivElement: any) {
                    var editorInfo = valueDivElement.__editorInfo;
                    if (editorInfo.destroy) {
                        editorInfo.destroy();
                    }
                });
            }
        }

        private notifyItemAddedOrRemoved() {
            if ((this.options as VerticalOrderedListBuilderOptions).itemAddedOrRemoved) {
                (this.options as VerticalOrderedListBuilderOptions).itemAddedOrRemoved();
            }
        }
    }

}
